import ExpoConstants from 'expo-constants';
import type { SendUnembeddedVisitorHome } from 'src/presentation/helpers/types/EmbedGuardTypes';

const SITE_URL = (ExpoConstants.expoConfig?.extra?.baseUrl as string | undefined) ?? '';

/**
 * The app host is where the build is served from, never an address anyone is handed: every link
 * into the app goes to <site>/app/<path>, which opens the app in the panel over the site. Someone
 * who still lands on the bare host (an old link, a bookmark, the no-script way out) is moved to
 * the same screen inside the site, so there is one address for a screen instead of two.
 */
export const sendUnembeddedVisitorHome: SendUnembeddedVisitorHome = () => {
	// The Metro dev server is opened directly on purpose, so it is the one host that keeps
	// serving the app on its own.
	const local = /^(localhost|127\.0\.0\.1)$/.test(window?.location?.hostname ?? '');

	if (typeof window === 'undefined' || window.parent !== window || SITE_URL === '' || local) {
		return;
	}

	const path = window.location.pathname.replace(/\/$/, '');

	window.location.replace(`${SITE_URL}/app${path}${window.location.search}`);
};

export default sendUnembeddedVisitorHome;
